import { createFileRoute } from '@tanstack/react-router'

import { BackupView } from '@/components/Internal/Backup/BackupView'

export const Route = createFileRoute('/internal/system/operations/backup')({
  component: BackupView,
})
